import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ApiEvent, ConnectionStatus } from "@evergis/api";

import { redirectToSignIn } from "utils/window";
import { api } from "evergis/api";
import { connectionChange, PublicConnectionStatus } from "ducks/sp/sp";
import { isLocationLoadProjectSelector } from "../../ducks/location/selectors";

export const useConnectionProblemEffect = () => {
  const dispatch = useDispatch();
  const isLocationLoadProject = useSelector(isLocationLoadProjectSelector);

  useEffect(() => {
    api.on(ApiEvent.ConnectionLost, () => {
      dispatch(connectionChange(ConnectionStatus.Lost));
    });

    api.on(ApiEvent.SessionClosed, async () => {
      if (!isLocationLoadProject) {
        // api.getSessionId();
      } else {
        await api.account.refreshToken({});
      }
    });

    api.on(ApiEvent.Unauthorized, async () => {
      dispatch(connectionChange(PublicConnectionStatus.Unauthorized));
      await api.account.logout();
      redirectToSignIn();
    });
  }, [dispatch, isLocationLoadProject]);
};
